angular.module('aprima-legacy-common').factory('LogOffService',
    ['$q', 'LogOffServiceTs',
        function ($q, LogOffServiceTs) {
            'use strict';

            return {
                logoff: logoff,
                logoffFromUnauthorizedResponse: logoffFromUnauthorizedResponse,
            };

            function logoff() {
                var promise = LogOffServiceTs.logoff();
                return $q.when(promise);
            }

            function logoffFromUnauthorizedResponse() {
                LogOffServiceTs.logoffFromUnauthorizedResponse();
            }
        }]);
